// extracted by mini-css-extract-plugin
export var pillWrapper = "_kl-0";
export var showOverflow = "_kl-1";